export default __webpack_public_path__ + "static/media/design-01.ff3cab82.png";